export default __webpack_public_path__ + "static/media/freeIcon.b98e2677.png";